import React, { useEffect, useState } from "react";
import "./css/preloader.css";

import desttopsizeloader from "../components/images/Preloader for Desktop screen.mp4";
import ForLargeSize from "../components/images/Preloader for Website.mp4";
import LaptopSize from "../components/images/Preloader for Laptop screen.mp4";
import MobileM from "../components/images/Preloader for Mobile M.mp4";
import MobileS from "../components/images/Preloader for Mobile S.mp4";
import Tablet from "../components/images/Preloader for Tablet screen.mp4";

const Preloader = () => {
    const [videoSrc, setVideoSrc] = useState(null);

    useEffect(() => {
        const updateVideo = () => {
            const width = window.innerWidth;

            if (width >= 1600) {
                setVideoSrc(ForLargeSize); // For very large screens
            } else if (width >= 1200) {
                setVideoSrc(desttopsizeloader); // Desktop
            } else if (width >= 992) {
                setVideoSrc(LaptopSize); // Laptop
            } else if (width >= 768) {
                setVideoSrc(Tablet); // Tablet
            } else if (width >= 480) {
                setVideoSrc(MobileM); // Mobile Medium
            } else {
                setVideoSrc(MobileS); // Mobile Small
            }
        };

        updateVideo();
        window.addEventListener("resize", updateVideo);
        return () => window.removeEventListener("resize", updateVideo);
    }, []);

    return (
        <div className="preloader">
            {videoSrc ? (
                <video
                    src={videoSrc}
                    autoPlay
                    loop
                    muted
                    playsInline

                    className="preloader-video"

                />
            ) : null}
        </div>
    );
};

export default Preloader;
